@if (entity === 'customer-company') {
  <app-ng-icon name="heroBuildingOffice"></app-ng-icon>
}
@if (entity === 'customer-individual') {
  <app-ng-icon name="heroUserGroup"></app-ng-icon>
}
@if (entity === 'project') {
  <app-ng-icon name="heroBriefcase"></app-ng-icon>
}
@if (entity === 'invoice') {
  <app-ng-icon name="heroBanknotes"></app-ng-icon>
}
